import React from 'react';
import Modal from 'react-modal';
import { FormattedMessage, injectIntl } from 'react-intl';
import OTButtonGroup from '../../tag/OTButtonGroup';
import OTButton from '../../tag/OTButton';
import Logger from '../../../utils/Logger';
import modal from '../../../definitions/Modal';

const { id: module_id } = module;
const logger = Logger(module_id);

const notificationModal = modal({
  content: { width: '300px', padding: '30px 50px' },
});

const AgreementCancelModal = ({ isOpen, closeModal, intl }) => {
  return (
    <Modal
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={notificationModal}
      // contentLabel={intl.formatMessage({id:`${module_id}.contentLabel`})}
    >
      <div className="text-center">
        <div className="row-fluid">
          <p>
            <FormattedMessage id={`${module_id}.query`} />
          </p>
        </div>
        <div className="row-fluid">
          <OTButtonGroup type={'big'} fullWidth expectedCount={2}>
            <OTButton onClick={() => closeModal('abort')}>
              <FormattedMessage id={'yes'} />
            </OTButton>
            <OTButton onClick={() => closeModal('cancel')}>
              <FormattedMessage id={'no'} />
            </OTButton>
          </OTButtonGroup>
        </div>
      </div>
    </Modal>
  );
};

export default injectIntl(AgreementCancelModal);
